import React from "react";
import {Spinner} from "react-bootstrap";

export default function Loader(){
    return (
        <Spinner animation="grow" className="m-auto"/>
    )
}